import axios from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

export const getOrders = async (store_id, id, page, isUser, filters = {}) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const selectedStoreId = JSON.parse(localStorage.getItem("selectedStore"));
    console.log("selectedStoreId", selectedStoreId);
    const storeId = selectedStoreId?.id ? selectedStoreId?.id : null;
    console.log("storeId", storeId);
    const { data } = await axios.get("/v1/admin/orders", {
      params: {
        page,
        store_id,
        courier_id: isUser ? "" : id,
        user_id: isUser ? id : "",
        from_date: filters.from,
        to_date: filters.to,
        ...filters,
      },
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
        "store-id": storeId,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const getOrdersStats = async () => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.get("/v1/admin/orders/stats", {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const showOrders = async (id) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.get(`/v1/admin/orders/${id}`, {
      params: {
        lang: lang,
      },
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        "Accept-Language": lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const postOrders = async (postData) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.post("/v1/admin/orders", postData, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const updateOrders = async (postData, id) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.post(
      `/v1/admin/orders/${id}/status`,
      postData,
      {
        headers: {
          Authorization: "Bearer " + `${brear}`,
          app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
          lang: lang,
        },
      },
    );
    return data;
  } catch (error) {
    throw error;
  }
};
export const updateOrdersAction = async (postData, id) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.post(
      `/v1/admin/orders/${id}/action`,
      postData,
      {
        headers: {
          Authorization: "Bearer " + `${brear}`,
          app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
          lang: lang,
        },
      },
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteOrders = async (id, lang) => {
  const brear = localStorage.getItem("token");
  const result = await Swal.fire({
    title: "هل انت متأكد ؟",
    text: "سيتم الحذف",
    icon: "warning",
    showCancelButton: true,
    cancelButtonColor: "#d33",
    confirmButtonText: "Okay",
  });
  if (result.isConfirmed) {
    try {
      const { data } = await axios.delete(`/v1/admin/orders/${id}`, {
        headers: {
          Authorization: "Bearer " + `${brear}`,
          app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
          AcceptLanguage: lang,
        },
      });
      if (data.success === true) {
        Swal.fire("Deleted!", `${data.message}`, "success");
      } else {
        Swal.fire("Not deleted", `${data.message}`, "info");
      }
      return data;
    } catch (error) {
      throw error;
    }
  }
};

export const getInvoice = async (id, setLoading) => {
  try {
    setLoading(true); // start loading
    const token = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");

    const response = await axios.get(`/v1/orders/${id}/invoice`, {
      responseType: "blob", // important for Blob/PDF
      headers: {
        Authorization: `Bearer ${token}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });

    // Create a downloadable URL
    const blob = new Blob([response.data], { type: response.data.type });
    const url = window.URL.createObjectURL(blob);

    // Optionally trigger download automatically
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `invoice_${id}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();

    setLoading(false); // stop loading
    return blob;
  } catch (error) {
    setLoading(false);

    toast.error(`حدث خطأ`);
  }
};


export const postCourierOrder = async (postData, orderId) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.post(
      `/v1/admin/orders/${orderId}/force-assign`,
      postData,
      {
        headers: {
          Authorization: "Bearer " + `${brear}`,
          app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
          lang: lang,
        },
      },
    );
    return data;
  } catch (error) {
    throw error;
  }
};